import { apiClient, orgApiPath, resolveActiveOrganizationId } from '@/core/api';
import type { FormatListItem, Template, TemplateSummary } from '@/types/api';

/** URL segment for org custom templates; stored ``format_id`` is ``custom-{organization_id}``. */
export const CUSTOM_FORMAT_PATH_ID = 'custom';

/** Map API format list ``id`` to persisted ``format_id`` on creatives and template payloads. */
export function storedFormatIdFromPath(formatPathId: string): string {
  if (formatPathId === CUSTOM_FORMAT_PATH_ID) {
    const org = resolveActiveOrganizationId();
    if (!org) throw new Error('No active organization');
    return `custom-${org}`;
  }
  return formatPathId;
}

/** Map stored ``format_id`` to the path segment used in org-scoped URLs. */
export function formatPathIdFromStored(formatId: string): string {
  if (formatId.startsWith('custom-')) return CUSTOM_FORMAT_PATH_ID;
  return formatId;
}

export async function listFormats(): Promise<FormatListItem[]> {
  return apiClient<FormatListItem[]>(orgApiPath('/formats'));
}

export async function listTemplatesForFormat(
  formatPathId: string,
): Promise<TemplateSummary[]> {
  return apiClient<TemplateSummary[]>(
    orgApiPath(`/formats/${encodeURIComponent(formatPathId)}/templates`),
  );
}

export async function getTemplateInFormat(
  formatPathId: string,
  templateId: string,
): Promise<Template> {
  return apiClient<Template>(
    orgApiPath(
      `/formats/${encodeURIComponent(formatPathId)}/templates/${encodeURIComponent(templateId)}`,
    ),
  );
}
